import React from 'react';

const Basket = () => (
  <path d="M6.51 6H4c-.5523 0-1-.4477-1-1s.4477-1 1-1h3.3606a1 1 0 0 1 .987.8396l.524 3.2229H27c.6128 0 1.0815.5462.9884 1.1518l-1.6803 10.9375a1 1 0 0 1-.9884.8482H9.7989a1 1 0 0 1-.987-.8396L6.51 6zm2.6867 4.0625L10.6494 19h13.8122l1.373-8.9375H9.1966zM24 29c-1.6569 0-3-1.3431-3-3s1.3431-3 3-3 3 1.3431 3 3-1.3431 3-3 3zm0-2c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1zm-13 2c-1.6569 0-3-1.3431-3-3s1.3431-3 3-3 3 1.3431 3 3-1.3431 3-3 3zm0-2c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1z" />
);

export default Basket;
